<template>
  <div v-if="!!userStore.currentTourDayItem" class="h-100">
    <v-loader v-if="props.status === 'loading' && suppliersStatus === 'loading'" />

    <form v-else id="template-day-item-resource-select" class="d-flex flex-column justify-content-between h-100">
      <div>
        <fieldset>
          <legend class="visually-hidden">{{ $t("tourBuilder.searchTourDayItemResource") }}</legend>

          <div class="form-outline">
            <label class="label">
              <span
                v-if="
                  (userStore.currentTourDayItem.type !== undefined &&
                    userStore.currentTourDayItem.type === 'stage_information') ||
                  userStore.currentTourDayItem.type === 'general_information'
                "
              >
                {{ $t("general.shared.selected") }}
              </span>
              <span v-else>
                {{ $t("general.shared.searchByNameOrLocation") }}
              </span>
            </label>
            <v-select
              v-if="
                (userStore.currentTourDayItem.type !== undefined &&
                  userStore.currentTourDayItem.type === 'stage_information') ||
                userStore.currentTourDayItem.type === 'general_information'
              "
              id="tour-day-item-supplier-select"
              v-model="supplier"
              :filterable="false"
              :options="stageResouce"
              class="select-search"
              label="name"
              @search="onSearch"
              @option:selected="loadResouceSelected"
            >
              <template v-slot:no-options>
                {{ $t("tourBuilder.writeSearchResources") }}
              </template>

              <template v-slot:option="option">
                <div class="d-center">
                  <span>{{ option?.title }}</span>
                </div>
              </template>

              <template v-slot:selected-option="option">
                <div class="selected d-center py-8">
                  <span>{{ option?.title }}</span>
                </div>
              </template>

              <template #list-footer>
                <li ref="load" class="create-client">
                  <v-button
                    class="btn-icon h-fit fw-normal shadow-none py-0 px-16"
                    size="sm"
                    variant="link"
                    @mousedown.prevent
                    @click.stop="openOffCanvas('the-resource-create-offcanvas')"
                  >
                    <v-icon icon="plus" size="xs" space="me-8" />
                    {{ $t("clientTour.createResource") }}
                  </v-button>
                </li>
              </template>
            </v-select>
            <v-select
              v-else
              id="tour-day-item-supplier-select"
              v-model="supplier"
              :filterable="false"
              :options="suppliers"
              class="select-search"
              label="name"
              @search="onSearch"
              @option:selected="loadSupplierSelected"
            >
              <template v-slot:no-options>
                {{ $t("tourBuilder.writeSearchSuppliers") }}
              </template>

              <template v-slot:option="option">
                <div class="d-center">
                  <span class="text-sm fw-light ms-4">
                    ({{ $str.roundedToFixed($str.milesToKilometers(Number(option?.distance)), 1) }}
                    {{ $t("tourBuilder.KilometersShorted") }})
                  </span>

                  <span>{{ option?.name }}</span>

                  <span v-if="!!option?.locationName" class="text-sm fw-light ms-4">
                    ({{ option?.locationName }})
                  </span>
                </div>
              </template>

              <template v-slot:selected-option="option">
                <div class="selected d-center py-8">
                  <span>{{ option?.name }}</span>

                  <span v-if="!!option?.distance" class="text-sm fw-light ms-4">
                    ({{ $str.roundedToFixed($str.milesToKilometers(Number(option.distance)), 1) }}
                    {{ $t("tourBuilder.KilometersShorted") }})
                  </span>

                  <span v-if="!!option?.locationName" class="text-sm fw-light ms-4">
                    ({{ option?.locationName }})
                  </span>
                </div>
              </template>

              <template #list-footer>
                <li ref="load" class="create-client">
                  <v-button
                    class="btn-icon h-fit fw-normal shadow-none py-0 px-16"
                    size="sm"
                    variant="link"
                    @click="openOffCanvas('the-supplier-create-offcanvas')"
                  >
                    <v-icon icon="plus" size="xs" space="me-8" />
                    {{ $t("clientTour.createSupplier") }}
                  </v-button>
                </li>
              </template>
            </v-select>
          </div>

          <!-- eslint-disable-next-line max-len -->
          <div
            v-if="!!supplier && showProducts && !!supplier.id && stageResouce.length === 0"
            class="resources-container form-outline"
          >
            <div class="d-flex justify-content-between" v-if="supplier.type !== 'hotel'">
              <label class="label">
                <span>{{ $t("general.shared.products") }}</span>
              </label>

              <label class="label me-20 bg-light">
                <v-button
                  class="btn-rates p-0 mx-4"
                  variant="icon"
                  @click="openOffCanvas('the-supplier-details-rates-off-canvas')"
                >
                  <v-icon class="px-0" icon="euro" />
                </v-button>

                <v-button
                  class="btn-rates p-0 mx-4"
                  variant="icon"
                  @click="openOffCanvas('the-supplier-details-offcanvas')"
                >
                  <v-icon class="px-0" icon="pencil" />
                </v-button>

                <v-button class="btn-rates p-0 mx-4" variant="icon" @click="loadSupplierSelected">
                  <v-icon class="px-0" icon="refresh" />
                </v-button>
              </label>
            </div>

            <div v-if="!!resources && resources.length > 0" class="form-control">
              <div
                v-for="resource in resources"
                :key="resource.id"
                class="resource-item d-flex justify-content-between align-items-center py-4"
              >
                <v-checkbox
                  :id="`template-day-item-create-resource-${resource.id}`"
                  :for-key="`template-day-item-create-resource-${resource.id}`"
                  :label="resource.name"
                  class="form-check-inline me-32"
                  label-class="ms-0"
                  @update:modelValue="setResource($event, resource)"
                />

                <div v-if="!!checkExistResource(resource)" class="d-flex">
                  <v-button
                    v-if="checkExistResource(resource).quantity > 1"
                    class="p-0"
                    size="sm"
                    variant="icon"
                    @click="removeResource(resource)"
                  >
                    <v-icon icon="remove" size="sm" />
                  </v-button>

                  <div class="mx-8">{{ checkExistResource(resource).quantity }}</div>

                  <v-button class="p-0" size="sm" variant="icon" disabled @click="addResource(resource)">
                    <v-icon icon="circle-plus" size="sm" />
                  </v-button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset v-if="!!selectedResouce && !!supplier && !!supplier.id">
          <div class="selected d-center py-8">
            <div class="d-flex justify-content-center">
              <label class="label">
                <span>{{ $t("general.shared.basicInformation") }}</span>
              </label>
            </div>
            <div class="text-sm d-flex py-4">
              <span class="me-16 fw-medium">{{ $t("general.shared.title") }}: </span>
              <span>{{ selectedResouce?.title }}</span>
            </div>
            <div class="text-sm d-flex py-4">
              <span class="me-16 fw-medium">{{ $t("general.shared.location") }}: </span>
              <span>
                {{ selectedResouce?.location?.name }}
                <v-icon v-if="!!selectedResouce?.destination" icon="arrow-right" size="xs" space="px-8" />
                {{ selectedResouce?.destination }}
              </span>
            </div>
            <div class="text-sm d-flex py-4">
              <span class="me-16 fw-medium">{{ $t("general.shared.types") }}: </span>
              <span>{{ selectedResouce?.destination }}</span>
            </div>
            <div class="text-sm d-flex py-4">
              <span class="me-16 fw-medium">{{ $t("general.shared.description") }}: </span>
              <span v-html="selectedResouce?.description" />
            </div>
            <div class="search-separator-container mb-8">
              <div class="separator-text-container">
                <span class="separator-text text-sm">{{ $t("general.shared.links") }}</span>
              </div>
            </div>
            <div v-if="selectedResouce?.links" class="text-sm d-flex flex-column py-4">
              <span class="me-16 fw-medium">Links: </span>
              <template v-for="url in JSON.parse(selectedResouce?.links)" :key="url">
                <a :href="url" class="resource-link btn-link" rel="noopener noreferrer" target="_blank">
                  {{ url }}
                </a>
              </template>
            </div>
          </div>
        </fieldset>
      </div>
      <v-button
        v-if="
          userStore.currentTourDayItem.type === 'stage_information' ||
          userStore.currentTourDayItem.type === 'general_information'
        "
        :disabled="!selectedResouce || stageResouce.length === 0"
        class="btn-submit-form btn-icon w-fit align-self-end mt-8"
        size="sm"
        variant="primary"
        @click="createTourDayItemResource"
      >
        {{ $t("general.button.create") }}
        <v-icon icon="arrow-right" size="sm" space="ms-12" />
      </v-button>
      <v-button
        v-else
        :disabled="!supplier.id"
        class="btn-submit-form btn-icon w-fit align-self-end mt-8"
        size="sm"
        variant="primary"
        @click="createTourDayItemResource"
      >
        {{ $t("general.button.create") }}
        <v-icon icon="arrow-right" size="sm" space="ms-12" />
      </v-button>
      <!-- <v-button
          :disabled="!resourcesSelected || resourcesSelected.length === 0"
          class="btn-submit-form btn-icon w-fit align-self-end"
          size="sm"
          variant="primary"
          @click="createTourDayItemResource"
        >
          {{ $t('general.button.create') }}
          <v-icon icon="arrow-right" size="sm" space="ms-12"/>
        </v-button> -->
    </form>

    <the-supplier-details-rates-off-canvas
      v-if="offCanvasToShow === 'the-supplier-details-rates-off-canvas'"
      :supplier-id="supplier.id"
      @closed="closeOffCanvas"
    />

    <the-supplier-create-offcanvas
      v-if="offCanvasToShow === 'the-supplier-create-offcanvas'"
      @closed="closeOffCanvas"
      @reload-suppliers="closeOffCanvas"
      @open-details="supplier = $event"
    />

    <the-supplier-details-offcanvas
      v-if="offCanvasToShow === 'the-supplier-details-offcanvas'"
      :is-archived="false"
      :is-double-off-canvas="false"
      :supplier-data="supplier"
      @closed="
        closeOffCanvas();
        loadSupplierSelected();
      "
    />

    <the-resource-create-offcanvas
      v-if="offCanvasToShow === 'the-resource-create-offcanvas'"
      @closed="closeOffCanvas"
      @reload-resources="closeOffCanvas"
      @open-details="onResourceCreated"
    />
  </div>
</template>

<script lang="ts" setup>
import { getCurrentInstance, ref } from "vue";
import vSelect from "vue-select";
import { VCheckbox } from "@uniqoders/form";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import Supplier from "@/api/objects/Supplier";
import { useUserStore } from "@/stores/user";
import api from "@/api";
import SupplierResource from "@/api/objects/SupplierResource";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import TheSupplierDetailsRatesOffCanvas from "@/components/supplier/parts/TheSupplierDetailsRatesOffCanvas.vue";
import useOffCanvasUtils from "@/helpers/OffCanvasUtils";
import TheTemplateDayItemDetailsResourceForm from "@/components/template/TheTemplateDayItemDetailsResourceForm.vue";
import TheSupplierCreateOffcanvas from "@/components/supplier/TheSupplierCreateOffcanvas.vue";
import TheSupplierDetailsOffcanvas from "@/components/supplier/TheSupplierDetailsOffcanvas.vue";
import TheResourceCreateOffcanvas from "@/components/resource/TheResourceCreateOffcanvas.vue";
import Resource from "@/api/objects/Resource";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  agency: string;
  templateId: number;
  status: string;
}>();

const emit = defineEmits<{
  (e: "closed"): void;
  (e: "emitReloadTour"): void;
}>();
const { t } = useI18n();
const instance = getCurrentInstance();
const $toast = instance?.appContext.config.globalProperties.$toast;

const userStore = useUserStore();
const { offCanvasToShow, openOffCanvas, closeOffCanvas } = useOffCanvasUtils();

const resourceKey = ref<number>(0);
const suppliers = ref<Supplier[]>([]);
const stageResouce = ref<Resource[]>([]);
const supplier = ref<Supplier>({} as Supplier);
const resources = ref<SupplierResource[]>([]);
const resourcesMapped = ref<SupplierResource[]>([]);
const suppliersStatus = ref<string>("loading");
const resourceStatus = ref<string>("loading");
const mix = ref<string>("");
const resourcesSelected = ref<Record<string, any>[]>([]);
const resourcesNextStep = ref<boolean>(false);
const media = ref<any>(null);
const selectedResouce = ref<any>(null);
const showProducts = ref<boolean>(true);
const filters = ref<Record<string, any>>({
  mix: "",
  type: userStore.currentTourDayItem?.type || "",
});
const timers = ref<Record<string, any>>({
  mix: null,
});

const setItemResourceData = (value: any, resourceIndex: number, indexItemResources: number) => {
  const resource = resourcesSelected.value[resourceIndex]?.tourDayItemResources?.[indexItemResources];
  if (!resource) return;

  resource.observations = value.observations;
  resource.client_observations = value.client_observations;
  resource.nReserve = value.nReserve;
  resource.origin = value.origin;
  resource.destination = value.destination;
  resource.initHour = value.initHour;
  resource.endHour = value.endHour;
  resource.isOptional = value.isOptional;

  media.value = value.media;
};

const onSearch = (search: string, loading: (arg: boolean) => void) => {
  if (search.length) {
    loading(true);

    const isInfoType =
      userStore.currentTourDayItem?.type !== undefined &&
      (userStore.currentTourDayItem.type === "stage_information" ||
        userStore.currentTourDayItem.type === "general_information");

    if (isInfoType) {
      loadResources(loading, search);
    } else {
      loadSuppliers(loading, search);
    }
  }
};

const loadSuppliers = async (loading: (arg: boolean) => void, search: string) => {
  if (!userStore.currentTourDayItem) return;

  loading(true);

  try {
    const item = userStore.currentTourDayItem;
    const activityDay = item.activityDay || item.activity_day || null;
    const isStage = !!(
      item.isStage ??
      item.is_stage ??
      activityDay?.isStage ??
      activityDay?.is_stage
    );

    // Prefer explicitly injected locationId; otherwise mirror old builder:
    // stage → destination, rest → origin.
    let locationId = item.locationId ?? null;
    if (!locationId && activityDay) {
      locationId = isStage
        ? activityDay.destinationId ?? activityDay.destination_id
        : activityDay.originId ?? activityDay.origin_id;
    }

    const query = {
      filters: {
        type: item.type,
        mix: search,
      },
      location_id: locationId || undefined,
    };

    suppliers.value = await api.supplier.all(query);
  } catch (e: any) {
    console.error(e);
  } finally {
    suppliersStatus.value = "loaded";
    loading(false);
  }
};

const loadSupplierSelected = async () => {
  showProducts.value = supplier.value?.type !== "hotel";

  if (userStore.currentTourDayItem && supplier.value) {
    try {
      resourceStatus.value = "loading";

      const response = await api.supplier.retrieve(supplier.value.id);
      resources.value = response.resources;
    } catch (e: any) {
      console.error(e);
      $toast.error(e.response.data.message);
    } finally {
      resourceStatus.value = "loaded";
    }
  }
};

const loadResources = async (loading: (arg: boolean) => void, search: string) => {
  if (userStore.currentTourDayItem) {
    loading(true);

    try {
      const query = {
        filters: {
          type: userStore.currentTourDayItem.type,
          title: search,
        },
      };

      stageResouce.value = await api.resource.all(query);
    } catch (e: any) {
      console.error(e.response?.data);
    } finally {
      suppliersStatus.value = "loaded";
      loading(false);
    }
  }
};

const loadResouceSelected = async () => {
  if (userStore.currentTourDayItem && supplier.value) {
    try {
      resourceStatus.value = "loading";

      const response = await api.resource.retrieve(supplier.value.id);
      selectedResouce.value = response;
    } catch (e: any) {
      console.error(e.response?.data);
      $toast.error(e.response?.data?.message);
    } finally {
      resourceStatus.value = "loaded";
    }
  }
};

const onResourceCreated = (resource: Resource) => {
  if (!resource?.id) return;

  supplier.value = resource as unknown as Supplier;
  stageResouce.value = [resource, ...stageResouce.value.filter((existing) => existing.id !== resource.id)];
  loadResouceSelected();
};

const createTourDayItemResource = async () => {
  if (!userStore.currentTourDayItem) return;

  try {
    resourceStatus.value = "loading";

    const item = userStore.currentTourDayItem;

    if (item.type === "stage_information" || item.type === "general_information") {
      const data = {
        model_type: "resource",
        model_id: selectedResouce.value.id,
      };

      await api.activityService.updateDayItem(props.agency, props.templateId, item.activityDayId, item.id, data);
    } else if (item.type === "hotel") {
      const reqParam: Record<string, any> = {
        model_type: "supplier",
        model_id: supplier.value.id,
      };

      await api.activityService.updateDayItem(props.agency, props.templateId, item.activityDayId, item.id, reqParam);

      $toast.success(t("general.shared.savedChanges"));
    } else {
      const reqParam: Record<string, any> = {
        model_type: "supplier",
        model_id: supplier.value.id,
        supplier_resource_ids: resourcesSelected.value.map((el) => el.data.id),
      };

      await api.activityService.updateDayItem(props.agency, props.templateId, item.activityDayId, item.id, reqParam);
      
      $toast.success(t("general.shared.savedChanges"));
    }

    emit("emitReloadTour");

    const updateData = {
      agency: props.agency,
      templateId: props.templateId,
      templateDayId: item.tourDayId ?? item.activityDayId,
      templateDayItemId: item.id,
      locationId: item.locationId,
    };

    await userStore.setCurrentTemplateDayItemV2(updateData);
  } catch (e: any) {
    console.error(e);
    $toast.error(e.response?.data?.message);
  } finally {
    resourceStatus.value = "loaded";
  }
};

const setResource = (checkBoxValue: boolean, resource: SupplierResource | any) => {
  if (checkBoxValue) {
    addResource(resource);
  } else {
    removeResource(resource, true);
  }
};

const addResource = (resource: SupplierResource | any) => {
  if (!userStore.currentTourDayItem) return;

  const resourceExist = checkExistResource(resource);
  resourceKey.value += 1;

  const tourDayItemResource: Record<string, any> = {
    id: resourceKey.value,
  };

  if (resourceExist) {
    resourceExist.tourDayItemResources.push(tourDayItemResource);
    resourceExist.quantity += 1;
  } else {
    resourcesSelected.value.push({
      data: resource,
      quantity: 1,
      tourDayItemResources: [tourDayItemResource],
    });
  }
};

const removeResource = (resource: SupplierResource, isRemoveAllResource = false) => {
  const resourceExist = checkExistResource(resource);

  if (resourceExist) {
    if (resourceExist.quantity <= 1 || isRemoveAllResource) {
      resourcesSelected.value = resourcesSelected.value.filter((el) => el.data.id !== resource.id);
    } else {
      resourceExist.quantity -= 1;
    }
  }

  if (resourcesSelected.value.length === 0) {
    resourcesNextStep.value = false;
  }
};

const checkExistResource = (resource: SupplierResource | Record<string, any>): Record<string, any> | undefined => {
  return resourcesSelected.value.find((resourceAux) => resourceAux.data.id === resource.id);
};

const removeResourceFromAll = (resource: SupplierResource) => {
  removeResource(resource);
};

const removeTourDayItemResource = (
  resourceId: number,
  tourDayItemResource: Record<string, any>,
  IsRemoveAllResource = false
) => {
  const resourceExist = resourcesSelected.value.find((resourceAux) => resourceAux.data.id === resourceId);

  if (resourceExist) {
    if (resourceExist.quantity <= 1 || IsRemoveAllResource) {
      resourcesSelected.value = resourcesSelected.value.filter((el) => el.data.id !== resourceId);
    } else {
      resourceExist.quantity -= 1;
      resourceExist.tourDayItemResources = resourceExist.tourDayItemResources.filter(
        (el: Record<string, any>) => el.id !== tourDayItemResource.id
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-item {
  background-color: transparent;
}

.accordion .accordion-item .accordion-button {
  font-size: 1rem;
}

.accordion-button,
.accordion-button:not(.collapsed) {
  background-color: transparent;
}

:deep(.form-control),
:deep(.vs__selected),
:deep(.vs__dropdown-option) {
  font-size: 0.9375rem !important;
}

:deep(.v-form-label),
:deep(.form-check-label) {
  font-size: 0.8125rem !important;
}
</style>
